import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import CustomerForm from './CustomerForm'
import {
  createCustomerAction,
  updateCustomerAction
} from '@/redux/order/customerSlice'

class CustomerModal extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleOk = async (formRef) => {
    const { baseProps } = this.props
    const { editingCustomer, onSuccess } = baseProps || {}

    try {
      // 获取表单值
      const values = await formRef.current.validateFields()

      // 构建偏好对象
      const preferences = {}
      if (values.favoriteFood) {
        preferences.favoriteFood = values.favoriteFood.trim()
      }
      if (values.personality) {
        preferences.personality = values.personality.trim()
      }
      if (values.hobbies) {
        preferences.hobbies = values.hobbies.trim()
      }

      // 处理渠道：如果选择了"其他"，使用输入框的值
      const channel = values.channel === 'other' && values.otherChannel 
        ? values.otherChannel.trim() 
        : values.channel

      // 格式化数据
      const formData = {
        name: values.name,
        phone: values.phone,
        address: values.address,
        points: [Number(values.longitude), Number(values.latitude)],
        tags: values.tags || [],
        channel: channel,
        createdBy: values.createdBy,
        preferences: preferences
      }

      // 调用保存接口
      const dispatch = this.props.dispatch
      if (editingCustomer) {
        // 更新客户
        await dispatch(updateCustomerAction({
          customerId: editingCustomer.id,
          data: formData
        })).unwrap()
        message.success('更新成功')
      } else {
        // 创建客户
        await dispatch(createCustomerAction(formData)).unwrap()
        message.success('创建成功')
      }

      // 调用成功回调
      if (onSuccess) {
        onSuccess()
      }

      return true // 返回 true 关闭弹窗
    } catch (error) {
      console.error('保存客户失败:', error)
      if (error && typeof error === 'string') {
        message.error(error)
      } else if (error?.errorFields) {
        // 表单验证错误，不显示消息
      } else {
        message.error('操作失败')
      }
      return false // 返回 false 不关闭弹窗
    }
  }

  handleCancel = () => {
    const { baseProps } = this.props
    const { onCancel } = baseProps || {}
    if (onCancel) {
      onCancel()
    }
  }

  render() {
    const { children, baseProps, title } = this.props
    const { editingCustomer } = baseProps || {}
    const isEdit = !!editingCustomer

    const baseComponent = (
      <CustomerForm
        editingCustomer={editingCustomer}
        dispatch={this.props.dispatch}
        currentUser={this.props.currentUser}
      />
    )

    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || (isEdit ? '编辑客户' : '新建客户')}
        width={600}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        centerTitle
        className="center-title-modal"
      />
    )
  }
}

// 使用函数组件作为wrapper来使用React Redux Hooks
const CustomerModalWrapper = (props) => {
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.app?.user || {})

  const enhancedProps = {
    dispatch,
    currentUser,
    baseProps: {
      ...props.baseProps
    },
    ...props
  }

  return <CustomerModal {...enhancedProps} />
}

export default CustomerModalWrapper

